/* eslint-disable no-unused-vars */
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import "./Header.css";
import { BrowserRouter as Router, useHistory } from "react-router-dom";
import {
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";
import { Search, SentimentDissatisfied } from "@mui/icons-material";
import "./ProductCard.css"

const Header = ({ children, hasHiddenAuthButtons }) => {
const history = useHistory()

const handleHistory = () => {
  history.push("/")
}

const handleLogout = () => {
  localStorage.removeItem("username")
  localStorage.removeItem("balance")
  localStorage.removeItem("token")
  history.push("/")
  window.location.reload()
}

const handleLogin = () => {
  history.push("/login")
}

const handleRegister = () => {
  history.push("/register")
}

// console.log(children)
// console.log(hasHiddenAuthButtons)
  if(hasHiddenAuthButtons){
    return (
      <Box className="header">
        <Box className="header-title">
            <img src="logo_light.svg" alt="QKart-icon"></img>
        </Box>

        {children}

        <Button
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text"
          onClick={handleHistory}
        >
          Back to explore
        </Button>
      </Box>
    )
  }

    return (
      <Box className="header">
        <Box className="header-title">
            <img src="logo_light.svg" alt="QKart-icon"></img>
        </Box>
       
      {children}
      {/* {children ? 
        <Box sx={{ width: 500, maxWidth: '100%' }} >
          <TextField
            className="search-desktop"
            size="small"
            fullWidth
            InputProps={{
              // className: "search",
              endAdornment: (
                <InputAdornment position="end">
                  <Search color="primary" />
                </InputAdornment>
              ),
            }}
            placeholder="Search for items/categories"
            name="search"
            onChange={(e)=>performSearch(e.target.value)}
            value={searchKey}
            onChange={(e)=>{
              setSearchKey(e.target.value)
            }}
          />
        </Box>
      :null}        */}

        <Stack direction="row" spacing={1} alignItems="center">
          {localStorage.getItem("username") ? (
            <>
              <Avatar alt={localStorage.getItem("username")} src="avatar.png" />
              <p className="username-text">{localStorage.getItem("username")}</p>
              <Button variant="text" onClick={handleLogout}>
                LOGOUT
              </Button>
            </>
          ) : (
            <>
              <Button variant="text" onClick={handleLogin}>
                LOGIN
              </Button>
              <Button variant="contained" onClick={handleRegister}>
                REGISTER
              </Button>
            </>
          )}
        </Stack>
        
      </Box>
    );
};

export default Header;
